import { z } from "zod";
export var GitProviderNames;
(function (GitProviderNames) {
    GitProviderNames["Azure"] = "azure";
    GitProviderNames["Github"] = "github";
    GitProviderNames["Gitlab"] = "gitlab";
    GitProviderNames["Bitbucket"] = "bitbucket";
})(GitProviderNames || (GitProviderNames = {}));
export const GitProvider = z.nativeEnum(GitProviderNames);
